import { render } from "./OwnerOnboardingPage.vue?vue&type=template&id=4badb528&scoped=true&ts=true"
import script from "./OwnerOnboardingPage.vue?vue&type=script&lang=ts"
export * from "./OwnerOnboardingPage.vue?vue&type=script&lang=ts"

import "./OwnerOnboardingPage.vue?vue&type=style&index=0&id=4badb528&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4badb528"]])

export default __exports__